const Money = Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' });

class Variation {
  /** SKU/MPN strip: `'open'` shown, `'hiding'` slideUp running (ignore dup `hide_variation`), `'closed'` hidden. Reset fires multiple hides in one tick. */
  #skuMpnPhase = 'closed';

  constructor($form) {
    this.$form = $form;

    $form.on('found_variation', this.#found_variation.bind(this));
    $form.on('hide_variation', this.#hide_variation.bind(this));

    const $wrap = $form.parents().eq(2);
    this.$price = $wrap.find('.wc-block-components-product-price, .price');
    this.$stock = $wrap.find('.stock_wrap');
    this.$sku = $wrap.find('.sku');
    this.$subtotal = $wrap.find('.woocommerce-variation-subtotal');
    const $scope = $form.closest('.woocommerce, .woosq-popup');
    this.$skuMpn = $scope.length
      ? $scope.find('.product-sku-mpn--variable')
      : $form.closest('.product-type-variable').find('.product-sku-mpn--variable');
    this.$skuMpnModelGroup = this.$skuMpn.find('[data-sku-mpn-model]');
    this.$skuMpnPartGroup = this.$skuMpn.find('[data-sku-mpn-part]');
    this.$skuMpnDivider = this.$skuMpn.find('[data-sku-mpn-divider]');
    this.$skuMpnModelValue = this.$skuMpnModelGroup.find('.product-sku-mpn__value');
    this.$skuMpnPartValue = this.$skuMpnPartGroup.find('.product-sku-mpn__value');

    this.price_html = this.$price.html();
    this.stock_html = this.$stock.html();

    if (this.$skuMpn?.length) {
      this.$form.trigger('check_variations');
    }
  }

  static init(event) {
    let $form = $('.variations_form:last');
    if (event?.handleObj.type === 'woosq_loaded') {
      $form = $('.woosq-popup .variations_form');
    }
    if ($form.length !== 0) new Variation($form);
  }

  #found_variation(event, variation) {
    this.current_variation = variation;
    this.$price?.html(variation.price_html || this.price_html);
    this.$stock?.html(variation.availability_html || this.stock_html);
    if (this.$sku.siblings().length) {
      this.$sku?.html(variation.sku).prepend('SKU: ').show();
    } else {
      variation.sku ? this.$sku?.html(`SKU: ${variation.sku}`).slideDown() : this.$sku?.slideUp(400, () => this.$sku?.html(' '));
    }
    this.#updateSkuMpn(variation);
    this.#calculate_subtotal();
  }

  #variable_item_reset() {
    const $variableItems = this.$form.find('ul.variable-items-wrapper');
    $variableItems.find('li').removeClass('selected').attr('aria-checked', 'false').attr('tabindex', '-1');
    $variableItems.siblings('select').find('option[value!=""]').prop('selected', false);
  }

  #reset_variations(event) {
    this.#variable_item_reset();
    $(event.currentTarget).slideUp();
  }

  get_product_attributes() {
    return this.$form.data('product_attributes');
  }

  #hide_variation() {
    this.current_variation = null;
    this.$price?.html(this.price_html);
    this.$stock?.html(this.stock_html);
    this.$sku?.slideUp(400, () => this.$sku?.html(''));
    this.#updateSkuMpn(null);
    this.#calculate_subtotal();
  }

  /** @param {{ sku?: string, _cr_mpn?: string } | null | undefined} variation */
  #updateSkuMpn(variation) {
    if (!this.$skuMpn?.length) {
      return;
    }

    const sku = this.#toText(variation?.sku);
    const mpn = this.#toText(variation?._cr_mpn);
    const hasContent = sku !== '' || mpn !== '';
    hasContent ? this.#showSkuMpn(sku, mpn) : this.#hideSkuMpn();
  }

  /** @param {unknown} value */
  #toText(value) {
    return value == null ? '' : String(value).trim();
  }

  #showSkuMpn(sku, mpn) {
    const showModel = sku !== '';
    const showPart = mpn !== '';
    this.$skuMpnModelValue.text(sku);
    this.$skuMpnPartValue.text(mpn);
    this.$skuMpnModelGroup.css('display', showModel ? 'flex' : 'none');
    this.$skuMpnPartGroup.css('display', showPart ? 'flex' : 'none');
    this.$skuMpnDivider.css('display', showModel && showPart ? 'block' : 'none');
    this.#skuMpnPhase = 'open';
    this.$skuMpn.stop(true, false).slideDown(400);
  }

  #hideSkuMpn() {
    if (this.#skuMpnPhase === 'hiding') {
      return;
    }
    if (this.#skuMpnPhase !== 'open') {
      this.#applyHiddenSkuMpnState();
      return;
    }
    this.#skuMpnPhase = 'hiding';
    this.$skuMpn.stop(true, false).slideUp(400, () => this.#applyHiddenSkuMpnState());
  }

  #applyHiddenSkuMpnState() {
    this.#skuMpnPhase = 'closed';
    this.$skuMpnModelValue.text('');
    this.$skuMpnPartValue.text('');
    this.$skuMpnModelGroup.css('display', 'none');
    this.$skuMpnPartGroup.css('display', 'none');
    this.$skuMpnDivider.css('display', 'none');
    this.$skuMpn.hide();
  }

  #calculate_subtotal() {
    let subtotal = this.current_variation?.display_price * this.$form.find('[name=quantity]').val();
    const subtotal_html = subtotal > 0 ? '<label>Subtotal:</label>' + Money.format(subtotal) : null;
    const stock_html = subtotal > 0 && this.current_variation?.is_in_stock ? ' <span>|</span> <span class="in-stock">In Stock</span>' : ' <span>|</span> <span class="out-of-stock">Out of Stock</span>';
    const final_html = subtotal_html ? subtotal_html + stock_html : null;
    final_html ? this.$subtotal?.html(final_html).slideDown() : this.$subtotal?.slideUp(400, () => this.$subtotal?.html(''));
  }
}

Variation.init();
$(document.body).on('woosq_loaded', Variation.init);

$(document).on('change', '.variations_form .variations select', event => {
  $(event.target).removeClass('required').next().removeClass('required');
});

$(document).on('click', '.variations_form .single_add_to_cart_button', event => {
  const $this = $(event.target);
  const $form = $this.closest('form.variations_form');
  if ($this.is('.wc-variation-selection-needed')) {
    $form.find('select').each((i, select) => {
      const $select = $(select);
      if (!$select.val()) $select.addClass('required').next().addClass('required');
    });
  }
});

// single product  subtotal
$('.product-type-simple .qty').on('change', function () {
  const $this = $(this);
  const $form = $('form.cart');
  const $price = $form.find('.single-price');
  const quantity = $this.val();
  const price = $price.data('price');
  const subtotal = quantity * price;
  $form.find('.single-price').html(Money.format(subtotal));
});
